import { Component, OnInit } from '@angular/core';
import { OTPLoginComponent } from './../../otp-login/otp-login.component';
import { OTPLoginService } from './../../services/otp-login.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NotificationComponent } from './../notification/notification.component';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { rocketChatRemove } from '../../enums/rocketChatRemove';
import { safeJsonStringify } from '../../shared/utils';
import { HttpClient, HttpHeaders, HttpContext } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { SKIP_LOADER } from '../../interceptor/loader.interceptor';
import * as CryptoJS from 'crypto-js';
import * as _ from 'lodash';
import { switchMap } from 'rxjs/operators';
import { RocketChatService } from 'src/app/services/rocketChat.service';
import { LoginService } from 'src/app/services/login.service';

declare var $: any;
declare var jQuery: any;

@Component({
  providers: [OTPLoginComponent],
  selector: 'app-submit-otp',
  templateUrl: './submit-otp.component.html',
  styleUrls: ['./submit-otp.component.css'],
})
export class SubmitOtpComponent implements OnInit {
  public otpCode: string;
  isADUser: boolean = false;
  adUserEmailId: string;
  adUserId: string;
  loginModel: any;
  adUserPassword: string;
  secretKey = 'Secret message';
  showSpinner: Boolean = false;
  otpId: any;
  verifyOTPForm = new FormGroup({
    otpCode: new FormControl('', [Validators.required]),
  });
  returnUrl: string;
  errorMessage: string;
  companyList: any = [];
  selectedCompanyId: any;
  chatEngineURL: any;
  LoginDisabled: boolean;
  redirectPath: string;
  listOfCompanyDetails: any;
  eva: any;
  isEmailForCompany: string;
  isCompanyListDisable: boolean;
  companyConfig: { authLogin: string; twoFactor: string; normalLogin: boolean; };

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private rocketChatService: RocketChatService,
    private loginService: OTPLoginService,
    private initLoginService: LoginService,
    private modalService: NgbModal,
    private loginComponent: OTPLoginComponent,
    private httpClient: HttpClient
  ) { }

  ngOnInit() {
    this.otpId = this.route.snapshot.paramMap.get('otpId');
    console.log('this.otpId', this.otpId);
    // const userCredential = this.loginService.getUserCredential();
    // if(!userCredential.length) {
    //   this.router.navigate(['Submit/LoginOTP'])
    // }
    var token = localStorage.getItem('token');
    if (_.isNil(token)) {
      // this.getCompanies();
      this.hideTopBar();
    } else {
      //if already login
      this.showTopBar();
      // this.router.navigate(["dashboards/alpha"]);
      this.router.navigate([
        'structure',
        { outlets: { 'structure-outlet': 'dashboards/director-view' } },
      ]);
    }
  }

  hideTopBar() {
    $('.cat__top-bar').hide();
    $('.cat__menu-left').hide(); //hide the sidebar
    $('.cat__top-bar__right').hide(); //hide the logout icon
    $('.cat__footer').hide();
  }

  showTopBar() {
    $('.cat__menu-left').show();
    $('.cat__top-bar__right').show();
    $('.cat__top-bar').show();
    $('.cat__footer').show();
  }
  onlyNumber(ev) {
    var keyCode = window.event ? ev.keyCode : ev.which;
    //codes for 0-9
    if (
      (keyCode > 47 && keyCode < 58) ||
      (keyCode > 95 && keyCode < 106) ||
      keyCode == 8
    ) {
      // if (((keyCode > 47 && keyCode < 58) || (keyCode > 95 && keyCode < 106))) {
      // ev.preventDefault();
      // }
    } else {
      if (keyCode != 0 && keyCode != 8 && keyCode != 13 && !ev.ctrlKey) {
        ev.preventDefault();
      } else {
        ev.preventDefault();
      }
    }
  }

  getInputValueChange(event: Event): string {
    // @ts-ignore
    return (event.target ? (event.target as HTMLInputElement) : event).value;
  }

  getCompaniesByEmailId(userName: any) {
    //get array of company Id using email id
    this.listOfCompanyDetails = [];
    this.companyList = [];
    let emailId = userName;
    var CopyEmailAddress = '';

    if (emailId != '') {
      try {
        this.isEmailForCompany = 'Either due to low bandwidth or API unavailable';
        return this.initLoginService
          .getCompanyIdsByEmailId(emailId)
          .subscribe((companyIds) => {
            if (companyIds.status == 0) {
              if (companyIds.companyIds.length > 0) {
                localStorage.setItem('CopyEmailAddress', emailId);
                CopyEmailAddress = localStorage.getItem('CopyEmailAddress');
                this.initLoginService
                  .getCompanyListByIds(companyIds)
                  .subscribe((companies) => {
                    // @ts-ignore
                    if (companies.status == 0) {
                      this.isCompanyListDisable = false;
                      // @ts-ignore
                      this.listOfCompanyDetails = companies.companyList;
                      console.log("kuch bhi",this.listOfCompanyDetails);
                      // @ts-ignore
                      this.companyList = companies.companyList.map(company => {
                        return {
                          label: company.CompanyName,
                          value: company._id,
                        };
                      });
                      console.log(this.companyList);
                    } else {
                      this.companyList = [];
                    }
                  });
              } else {
                this.isCompanyListDisable = true;
                this.isEmailForCompany =
                  'Either due to low bandwidth or API unavailable';
              }
            } else {
              this.isEmailForCompany = 'Please enter valid email id';
              localStorage.removeItem('CopyEmailAddress');
            }
          });
      } catch (error) {
        console.log('error occured', error);
        this.isEmailForCompany =
          'Either due to low bandwidth or API unavailable';
      }
    }

    if (emailId == 'superadmin@gmail.com' || emailId == '') {
      this.companyConfig = {
        authLogin: 'Inactive',
        twoFactor: 'Inactive',
        normalLogin: true,
      };
    }
  }

  loginFunction() {
    this.getCompaniesByEmailId(this.loginModel.UserName);
    this.LoginDisabled = true;
    this.initLoginService.login(this.loginModel).subscribe((data) => {
      console.log("data", data);
      if (data.status == 202) {
        localStorage.removeItem('userToken');
        localStorage.setItem('emailId', this.loginModel.UserName);
        localStorage.setItem('companyId', this.loginModel.CompanyId);
        localStorage.setItem('mobileNumber', data.MobileNumber);
        this.loginService.clearUserCredential();
        this.loginService.setUserCredential(data);
        localStorage.setItem('userToken', data.token);
        localStorage.setItem('companyEVA', null);
        this.redirectPath = decodeURIComponent(`${window.location.hash.split('returnUrl=')[1]}`)
        console.log('this.redirectPath', this.redirectPath)

        if (this.redirectPath == 'undefined') {
          this.router.navigate(['Submit/LoginOTP']);
          console.log('login 1')
        }
        else {
          this.router.navigate(['Submit/LoginOTP'], { queryParams: { returnUrl: this.redirectPath } });
          console.log('login 2')
        }

        const modalRef = this.modalService.open(NotificationComponent);
        modalRef.componentInstance.notify = {
          status: 'Success',
          message: data.message,
        };
      } else {
         const self = this; 
        let listOfCompany = _.groupBy(self.listOfCompanyDetails, '_id'); 
        let companyNameAndValue = this.companyList.find(function (company) {
          return company.value == localStorage.getItem("companyId");
        });
        console.log("company list: "+self.listOfCompanyDetails);
        console.log("company list: "+JSON.stringify(listOfCompany));
        console.log("company name value: "+companyNameAndValue);
        let companyData = _.first(listOfCompany[localStorage.getItem("companyId")]);
        this.chatEngineURL = _.get(companyData, 'ChatEngineURL');
        this.eva = _.get(companyData, 'EVA');
        console.log("company data: "+companyData);
        console.log("eva: "+this.eva);
        if (data.status == 0) {
          this.LoginDisabled = false;

          if (rocketChatRemove.isRemove.toString() != 'true') {
            let loginChatModel: any;
            loginChatModel = {
              user: data.user.RocketChatUserName,
              password: data.user.RocketChatPassword,
            };

            this.rocketChatService
              .loginToRocketChat(loginChatModel, this.chatEngineURL)
              .then((rocketChatData) => {
                if (rocketChatData.status == 'success') {
                  // Switching to the subsidiary data ----start
                  localStorage.setItem('isSubsidiary', 'false');
                  // Switching to the subsidiary data ----end
                  localStorage.setItem(
                    'companyDetailsGoveva',
                    safeJsonStringify({
                      companyName: data.user.CompanyName,
                      companyID: data.user.CompanyId,
                    })
                  );
                  localStorage.setItem(
                    'companyDetails',
                    safeJsonStringify({
                      companyName: data.user.CompanyName,
                      companyID: data.user.CompanyId,
                    })
                  );
                  localStorage.setItem('user', safeJsonStringify(data.user));

                  localStorage.setItem('companyEVA', this.eva);
                  if (data.user.FirstTimeLogin) {
                    localStorage.setItem(
                      'rocketAuth',
                      rocketChatData.data.authToken
                    );
                    localStorage.setItem(
                      'rocketUserId',
                      rocketChatData.data.userId
                    );
                    localStorage.setItem('rocketBaseURL', this.chatEngineURL);

                    this.router.navigate(['/changePassword']);
                  } else {
                    localStorage.setItem('userToken', data.token);
                    localStorage.setItem('token', data.token);
                    localStorage.setItem(
                      'resources',
                      safeJsonStringify(data.resources)
                    );

                    localStorage.setItem(
                      'rocketAuth',
                      rocketChatData.data.authToken
                    );
                    localStorage.setItem(
                      'rocketUserId',
                      rocketChatData.data.userId
                    );
                    localStorage.setItem('rocketBaseURL', this.chatEngineURL);

                    self.showTopBar();

                    self.returnUrl =
                      self.route.snapshot.queryParams['returnUrl'] || '/';

                    if (self.returnUrl != '/') {
                      try {
                        var check64 =
                          btoa(atob(this.returnUrl)) == this.returnUrl;
                      } catch (err) {
                        var check64 = false;
                      }
                      if (check64 == true) {
                        this.returnUrl = atob(this.returnUrl);
                      } else {
                        this.returnUrl = this.returnUrl;
                      }
                      if (_.includes(self.returnUrl, 'http')) {
                        window.open(self.returnUrl, '_self');
                      } else {
                        const urlAfterSplit = self.returnUrl.split(':');
                        const lastElement = urlAfterSplit[urlAfterSplit.length - 1];
                        const redirectUrl = _.first(lastElement.split(')'));
                        this.router.navigate([
                          'structure',
                          { outlets: { 'structure-outlet': redirectUrl } },
                        ]);
                      }
                    }
                    else {
                      self.router.navigate([
                        'structure',
                        { outlets: { 'structure-outlet': 'dashboards/director-view' } },
                      ]);
                    }
                  }
                }
              });
          } else {
            // Switching to the subsidiary data ----start
            localStorage.setItem('isSubsidiary', 'false');
            // Switching to the subsidiary data ----end
            localStorage.setItem(
              'companyDetailsGoveva',
              safeJsonStringify(companyNameAndValue)
            );
            localStorage.setItem(
              'companyDetails',
              safeJsonStringify({
                companyName: data.user.CompanyName,
                companyID: data.user.CompanyId,
              })
            );
            localStorage.setItem('userToken', data.token);
            localStorage.setItem('token', data.token);
            localStorage.setItem('user', safeJsonStringify(data.user));
            localStorage.setItem('companyEVA', this.eva);
            sessionStorage.setItem('SessionName', 'userLoggedIn');

            if (data.user.FirstTimeLogin) {
              localStorage.setItem('rocketBaseURL', this.chatEngineURL);
              // this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
              localStorage.setItem('token', data.token);
              this.router.navigate(['/changePassword']);
            } else {
              localStorage.setItem('token', data.token);
              localStorage.setItem(
                'resources',
                safeJsonStringify(data.resources)
              );

              localStorage.setItem('rocketBaseURL', this.chatEngineURL);

              this.showTopBar();

              this.returnUrl =
                this.route.snapshot.queryParams['returnUrl'] || '/';

              if (this.returnUrl != '/') {
                try {
                  var check64 = btoa(atob(this.returnUrl)) == this.returnUrl;
                } catch (err) {
                  var check64 = false;
                }
                if (check64 == true) {
                  this.returnUrl = atob(this.returnUrl);
                } else {
                  this.returnUrl = this.returnUrl;
                }

                if (
                  _.includes(self.returnUrl, 'http') ||
                  _.includes(self.returnUrl, 'https')
                ) {
                  window.open(self.returnUrl, '_self');
                } else {
                  const urlAfterSplit = self.returnUrl.split(':');
                  const lastElement = urlAfterSplit[urlAfterSplit.length - 1];
                  const redirectUrl = _.first(lastElement.split(')'));

                  this.router.navigate([
                    'structure',
                    { outlets: { 'structure-outlet': redirectUrl } },
                  ]);
                }
              } else {
                self.router.navigate([
                  'structure',
                  { outlets: { 'structure-outlet': 'dashboards/director-view' } },
                ]);
                // .then(() => {
                //   location.reload();
                // });
              }
            }
          }
        } else {
          this.LoginDisabled = false;
          $('#alertTitle').css('color', '#f00');
          $('#alertTitle').text('Failure!');
          $('#alertMessage').css('color', '#f00');
          $('#messagePopUp').modal('toggle');
          $('#alertMessage').text(data.message);
          this.messagePopUpTimeoutToogle();
          // this.socialAuthService
          //   .signOut()
          //   .then((resData) => {
          //     console.log('resData', resData);
          //   })
          //   .catch((error) => {
          //     console.log('errorerrorerror', error);
          //   });
          self.router.navigate(['/login']);
        }
      }
    });
  }


  messagePopUpTimeoutToogle() {
    setTimeout(function () {
      var popUpClass = $('#messagePopUp').attr('class');
      if (popUpClass == 'modal fade show') {
        $('#messagePopUp').modal('toggle');
      }
    }, 5000);
  }
  /**
   *  OTP VERIFICATION FOR LOGIN
   *  Below function is used to verify the OTP for login.
   *  If mobile number does not exist into the database user will not able to login.
   */
  submitOTP() {
    if (this.verifyOTPForm.valid) {
      const emailId = localStorage.getItem('emailId');
      const companyId = localStorage.getItem('companyId');
      const userToken = localStorage.getItem('userToken');
      const mobileNumber = localStorage.getItem('mobileNumber');
      const isForgotPassword = localStorage.getItem('isForgotPassword') === 'true';

      if (!emailId || !companyId || !userToken) {
        this.modalService.open(NotificationComponent).componentInstance.notify = {
          status: 'Failure',
          message: 'Session expired. Please try logging in again.'
        };
        this.router.navigate(['/login']);
        return;
      }

      const userObject = {
        EmailId: emailId,
        CompanyId: companyId,
        MobileNumber: mobileNumber,
        SecretCode: this.verifyOTPForm.get('otpCode').value,
        userToken: userToken
      };

      console.log('Submitting OTP with user object:', userObject);

      this.loginService.submitOTP(userObject).then((result) => {
        console.log('OTP verification successful, starting session setup...');

        if (result.status === 0) {
          // First update activity time
          const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'x-access-token': result.userToken
          });

          // Set up user session first
          console.log('Setting up user session...');

          // Store user details
          localStorage.setItem('user', safeJsonStringify(result.userDetails));
          localStorage.setItem('userToken', result.userToken);

          console.log('User details stored');

          // Store company details
          const companyDetails = {
            companyName: result.userDetails.CompanyName,
            companyID: result.userDetails.CompanyId
          };
          localStorage.setItem('companyDetails', safeJsonStringify(companyDetails));
          localStorage.setItem('companyDetailsGoveva', safeJsonStringify({
            label: result.userDetails.CompanyName,
            value: result.userDetails.CompanyId
          }));
          console.log('Company details stored');
          const agent = window.navigator.userAgent.toLowerCase();
          const notification_type = agent ? 'Browser' : 'Ipad';

          this.loginModel = {
            UserName: _.toLower(result.userDetails.UserName),
            CompanyId: result.userDetails.CompanyId,
            NotificationType: notification_type,
            socialLogin: null,
            Password: result.userDetails.Password,
            loginType: "OTP"
          };


          this.loginService
            .clearTokenByUserAgent(this.loginModel)
            .subscribe((tokenResult) => {
              if (tokenResult.status == 0) {
                console.log('user token cleared');

              }
            });

          this.loginFunction();
          // Set session storage
          // sessionStorage.setItem('SessionName', 'userLoggedIn');
          // console.log('Session storage set');

          // // Store token
          // // localStorage.setItem('token', result.userToken);
          // // console.log('Token stored');

          // // Set subsidiary flag
          // localStorage.setItem('isSubsidiary', 'false');
          // console.log('Subsidiary flag set');

          // // Set resources for route guard
          // const defaultResources = [
          //   { Menu: 'dashboards/alpha' },
          //   { Menu: 'structure' }
          // ];
          // localStorage.setItem('resources', safeJsonStringify(defaultResources));
          // console.log('Resources set');

          // // Show top bar
          // this.showTopBar();

          // // Navigate to dashboard
          // this.router.navigate(['/structure']).then(() => {
          //   this.router.navigate(['/structure', { outlets: { 'structure-outlet': 'dashboards/alpha' } }]);
          // }).catch(error => {
          //   console.error('Navigation error:', error);
          //   this.modalService.open(NotificationComponent).componentInstance.notify = {
          //     status: 'Failure',
          //     message: 'Failed to navigate to dashboard. Please try logging in again.'
          //   };
          //   this.router.navigate(['/login']);
          // });
        } else {
          console.error('OTP verification failed:', result);
          this.errorMessage = result.message || 'Invalid OTP. Please try again.';
        }
      }).catch(error => {
        console.error('OTP submission error:', error);
        this.errorMessage = 'Failed to verify OTP. Please try again.';
      });
    }

  }

  changePassword() {
    this.router.navigate(['/changePassword']);
  }

  async sendOTP() {
    var emailId = localStorage.getItem('emailId');
    var companyId = localStorage.getItem('companyId');
    const mobileNumber = localStorage.getItem('mobileNumber');
    var checkUserDetails = {
      EmailId: emailId,
      CompanyId: companyId, // check for the company ID
      MobileNumber: mobileNumber,
    };

    var getUserEmail = await this.loginService.getUserEmail(checkUserDetails);

    // .then(userEmailResult => {
    console.log('userEmailResult', getUserEmail);
    if (!getUserEmail.status) {
      if (getUserEmail.userDetails[0].ADID) {
        this.isADUser = true;
        this.adUserEmailId = getUserEmail.userDetails[0].EmailId;
        console.log('this.adUserEmailId', this.adUserEmailId);
      }
    } else {
      const modalRef = this.modalService.open(NotificationComponent);
      modalRef.componentInstance.notify = {
        status: 'Failure',
        message: getUserEmail.message,
      };
      return;
    }

    // });
    if (this.isADUser) {
      console.log('emailId', this.adUserEmailId);
      var loginOTPObject = {
        EmailId: this.adUserEmailId,
        CompanyId: companyId, // check for the company ID
        MobileNumber: mobileNumber,
      };
      console.log('loginOTPObject', loginOTPObject);
    } else {
      var loginOTPObject = {
        EmailId: emailId,
        CompanyId: companyId, // check for the company ID
        MobileNumber: mobileNumber,
      };
    }

    this.loginService.wrongOTPAttemptCheck(loginOTPObject).then((result) => {
      if (!result.status) {
        if (result.SecretCodeAttempt >= 5) {
          const modalRef = this.modalService.open(NotificationComponent);
          modalRef.componentInstance.notify = {
            status: 'Failure',
            message:
              'You have entered the wrong OTP five times.It will unblock after 15 minutes. Old OTP will not work after 15 minutes, So Generate new OTP after 15 Minutes.',
          };

          this.router.navigate(['login']);
        } else {
          this.loginService.submitEmail(loginOTPObject).then((response) => {
            if (!response.status) {
              localStorage.removeItem('userToken');
              localStorage.setItem('emailId', emailId);
              localStorage.setItem('companyId', companyId);
              this.loginService.clearUserCredential();
              this.loginService.setUserCredential(response);
              if (typeof response.userToken === 'string') {
                localStorage.setItem('userToken', response.userToken);
              } else if (response.userToken && typeof response.userToken === 'object') {
                console.warn('submitOTP(): userToken is an object — check your API.');
                localStorage.setItem('userToken', JSON.stringify(response.userToken));
              }

              // this.router.navigate(["Submit/LoginOTP"])
              const modalRef = this.modalService.open(NotificationComponent);
              modalRef.componentInstance.notify = {
                status: 'Success',
                message: response.message,
              };
            } else {
              // show error message to the user
              const modalRef = this.modalService.open(NotificationComponent);
              modalRef.componentInstance.notify = {
                status: 'Failure',
                message: response.message,
              };
              // this.modalService.open(NotificationComponent).result.then(result => {

              // })
            }
          });
        }
      } else {
        // show error message to the user
        const modalRef = this.modalService.open(NotificationComponent);
        modalRef.componentInstance.notify = {
          status: 'Failure',
          message: result.message,
        };
      }
    });
  }



}
